import { BookingSearchResponse } from "../../../Api/BookingSearch/Model/BookingSearchResponse.csharp";
import { Http } from "../Http";

export class BookingSearchApi {
  public search = (
    query: string,
    centerIds: string[] = [],
    takeDoctors?: number,
    takeServices?: number,
    takeSpecializations?: number
  ): Promise<BookingSearchResponse> => {
    const params = new URLSearchParams({ query });

    if (takeDoctors) params.append("takeDoctors", takeDoctors.toString());
    if (takeServices) params.append("takeServices", takeServices.toString());
    if (takeSpecializations)
      params.append("takeSpecializations", takeSpecializations.toString());

    centerIds.forEach((id) => params.append("centers", id));

    return Http.get(
      `/api/booking-search?${params.toString()}`,
      null
    ) as Promise<BookingSearchResponse>;
  };
}
